
export enum CustomerNoteTypeCd {
	APPROVER = 'Approver',
	CREDIT = 'Credit',
	GENERAL = 'General',
	REQUESTER = 'Requester',
	SPECIALIST = 'Specialist'}
